module.exports = __webpack_public_path__ + "6a549d47526475d0e7eb0a09e15dec61.ttf";